const loadingModule = {
    state: {
        userWidth: window.innerWidth,
        loadignState: false,
        loadingView: ''
    },
    mutations: {
        setLoadingState(state, payload) {
            state.loadignState = payload.loadignState
            state.loadignState ? state.loadingView = payload.loadingView : state.loadingView = ''
        },

        setUserWidth(state, payload) {
            state.userWidth = payload
        },
    },
    actions: {
        setLoadingState({ commit }, payload) {
            commit('setLoadingState', payload)
        },

        setUserWidth({ commit }, payload) {
            commit('setUserWidth', payload)
        }
    },
    getters: {
        getUserWidth: (state) => state.userWidth,
        loadingState: (state) => state.loadignState,
        loadingView: (state) => state.loadingView
    }
};

export default loadingModule;